<template>
  <b-card>
    <h5>Detalle de los lotes a facturar</h5>
    <b-table
      class="bg-white"
      small
      :fields="columns"
      :items="mappedReceiptDataTable"
      responsive="sm"
    >

    </b-table>
  </b-card>
</template>
<script>
export default {
  props: [
    'columns',
    'mappedReceiptDataTable'
  ]
};
</script>
